import React from 'react';
import styled from 'styled-components';
import Toast, { ToastProps } from './Toast';
import { spacing } from '../../design-system/tokens/spacing';

const Container = styled.div`
  position: fixed;
  top: ${spacing[5]};
  right: ${spacing[5]};
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};

  @media (max-width: 768px) {
    top: ${spacing[4]};
    right: ${spacing[4]};
    left: ${spacing[4]};
    max-width: calc(100% - ${spacing[8]});
  }
`;

interface ToastContainerProps {
  toasts: ToastProps[];
  onClose: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  onClose,
}) => {
  return (
    <Container>
      {toasts.map(toast => (
        <Toast key={toast.id} {...toast} onClose={onClose} />
      ))}
    </Container>
  );
};

export default ToastContainer;
